import script from "./whyChoose.vue?vue&type=script&setup=true&lang=js"
export * from "./whyChoose.vue?vue&type=script&setup=true&lang=js"

import "./whyChoose.vue?vue&type=style&index=0&id=26595c57&scoped=true&lang=css"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26595c57"]])

export default __exports__